import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';
import { Checkbox } from '../../../components/ui/checkbox';
import { ExternalLink } from 'lucide-react';

export const ConsentSection = ({ formData, handleChange, setShowPrivacyModal }) => (
    <Card className="border-blue-200 bg-blue-50">
      <CardContent className="p-6">
        <div className="flex items-start gap-3">
          <Checkbox
            id="consent"
            checked={formData.consent_given}
            onCheckedChange={(checked) => handleChange('consent_given', checked)}
            className="mt-1"
            required
          />
          <div className="flex-1">
            <Label 
              htmlFor="consent" 
              className="text-sm font-medium text-slate-900 cursor-pointer"
            >
              I consent to the storage and processing of my personal and medical data for healthcare purposes
              <span className="text-red-500 ml-1">*</span>
            </Label>
            <p className="text-xs text-slate-600 mt-2">
              By checking this box, you acknowledge that your data will be stored securely and used solely for providing healthcare services in compliance with the Digital Personal Data Protection Act (DPDPA), 2023.
            </p>
            <button
              type="button"
              onClick={() => setShowPrivacyModal(true)}
              className="text-xs text-blue-600 hover:text-blue-800 underline mt-2 flex items-center gap-1"
            >
              Read our Privacy Policy <ExternalLink className="w-3 h-3" />
            </button>
          </div>
        </div>
        {!formData.consent_given && (
          <p className="text-xs text-amber-600 mt-3 ml-7">
            ⚠️ Consent is mandatory to proceed with patient registration
          </p>
        )}
      </CardContent>
    </Card>

);
